import { LogUserActivity } from '@/apis/users/requests'
import { AppRoutePaths } from '@/routing/route_paths'
import { RootState } from '@/storage/store'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { LOG_TYPES } from '../../constants'
import useTaxableIncomeDocumentParams from '../hooks/useTaxableIncomeDocumentParams'
import { SkipVerification } from '../skip-verification/SkipVerification'
import { CaptureInstructionsPage } from './capture-instructions'

export const CaptureInstructionsTaxable = () => {
  const { info, onRouteChange, onTaxFormSelect } =
    useTaxableIncomeDocumentParams()
  const [skip, setSkip] = useState(false)
  const FamilyApplication = useSelector(
    (state: RootState) => state.FamilyApplication
  )
  const { select_household_member, document_capture } =
    AppRoutePaths.family_application.income_verification

  const selectedForm = info()

  const hasLoggedPageView = useRef(false);
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      logViewFormCaptureInstruction(selectedForm.code)
      hasLoggedPageView.current = true;
    }
  }, [])

  const logViewFormCaptureInstruction = (code:string) => {
    const suffix_text = code.includes("form") ? `${code.replace("form_", "").toUpperCase()} Form capture information page` : code == "non_taxable" ? "Non taxable capture instructions page" : ""
    if(suffix_text.length > 0)      
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text
      })
  }

  function handleContinueClick() {
    onRouteChange(document_capture)
  }

  function handleCantFindClick() {
    const isDual =
      FamilyApplication.data?.household_income_type === 'dual_income'
    const isFilingJointly =
      FamilyApplication.data?.household_filed_federal_income === 'jointly'

    if (isDual && isFilingJointly) {
      onRouteChange(select_household_member)
      return
    }

    if (selectedForm.name === 'form_1040') {
      logViewFormCaptureInstruction("form_w2")
      onTaxFormSelect('form_w2')
    }
    if (selectedForm.name === 'form_w2') {
      logViewFormCaptureInstruction("form_1099")
      onTaxFormSelect('form_1099')
    }

    if (selectedForm.name === 'form_1099') {
      logViewFormCaptureInstruction("non_taxable")
      onTaxFormSelect('nontaxable')
    }
    if (selectedForm.name === '') {
      setSkip(true)
    }

    // TODO. Add nontaxable upload as next step.
  }

  if (skip) {
    return (
      <SkipVerification
        onCancel={() => {
          setSkip(false)
        }}
      />
    )
  }

  return (
    <CaptureInstructionsPage
      name={selectedForm?.name}
      onCantFindClick={handleCantFindClick}
      onContinueClick={handleContinueClick}
    />
  )
}
